import React from 'react'
import { DsStack } from '@am92/react-design-system'

import SectionInfo from '~/src/Components/SectionInfo'

import { T_LANDING_PAGE_CONSTANTS } from '../Landing.PageConstants/TYPES'

import LIKE_ICON from '~/src/Assets/ICONS/LIKE_ICON'

interface IHighlightSectionProps {
  PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS
}

const HighlightSection: React.FC<IHighlightSectionProps> = props => {
  const { PAGE_CONSTANTS } = props

  return (
    <DsStack
      direction='column'
      alignItems='center'
      sx={{
        backgroundColor: 'var(--ds-colour-actionSecondary)',
        color: 'var(--ds-colour-typoOnSurface)',
        py: {
          xs: 'var(--ds-spacing-mild)',
          md: 'var(--ds-spacing-hot)'
        },
        px: {
          xs: 'var(--ds-spacing-bitterCold)',
          md: 'var(--ds-spacing-hot)'
        }
      }}
    >
      <SectionInfo
        icon={LIKE_ICON}
        title={PAGE_CONSTANTS.HIGHLIGHT_TITLE}
        description={PAGE_CONSTANTS.HIGHLIGHT_DESCRIPTION}
        StackProps={{
          sx: { mt: 'var(--ds-spacing-frostbite)' }
        }}
      />
    </DsStack>
  )
}

export default HighlightSection
